import AiInPat from "./AiInPat";
import IntegrationSupport from "./IntegrationSupport";
import PatPromptTemplates from "./PatPromptTemplates";
import ResearchFoundations from "./ResearchFoundations";

export interface BlogPost {
  slug: string;
  title: string;
  date: string;
  isoDate: string;
  description: string;
  readingTime: string;
  metaDescription: string;
  component: React.ComponentType;
}

// Newest first
export const blogPosts: BlogPost[] = [
  {
    slug: "research-foundations",
    title:
      "Research Foundations: The Evidence Base for Psychedelic-Assisted Therapy",
    date: "February 26, 2026",
    isoDate: "2026-02-26",
    description:
      "Psychedelic-assisted therapy is the most rigorously studied new paradigm in mental health treatment in decades. This post maps the evidence base every PAT practitioner should know — from MDMA and psilocybin trials to therapeutic modalities, outcome measures, and the documentation gap MycenAI is designed to fill.",
    readingTime: "11 min read",
    metaDescription:
      "Comprehensive overview of the psychedelic-assisted therapy evidence base for clinicians. Covers MDMA for PTSD, psilocybin for depression, ketamine-assisted psychotherapy, key therapeutic modalities (IFS, SE, ACT), validated outcome measures (MEQ30, 5D-ASC, PCL-5), and clinical documentation frameworks for PAT practice.",
    component: ResearchFoundations,
  },
  {
    slug: "integration-in-pat",
    title:
      "Integration in Psychedelic-Assisted Therapy: Documenting the Most Critical Phase",
    date: "February 26, 2026",
    isoDate: "2026-02-26",
    description:
      "The psychedelic experience is not the therapy. Integration — making meaning, consolidating insights, and translating experiences into lasting change — is what determines outcomes. Here is how to document it.",
    readingTime: "10 min read",
    metaDescription:
      "Guide to documenting integration in psychedelic-assisted therapy. Covers SOAP notes, meaning-making, trauma-informed processing, insight tracking, modality-specific approaches (IFS, somatic, ACT, transpersonal), and document chaining for PAT practitioners.",
    component: IntegrationSupport,
  },
  {
    slug: "pat-prompt-templates",
    title:
      "Clinical Prompt Templates for PAT Practitioners: A Practical Guide",
    date: "February 26, 2026",
    isoDate: "2026-02-26",
    description:
      "The quality of AI-generated clinical documentation depends entirely on the prompt. This guide introduces the MycenAI Clinical Prompt Library and explains how structured, PAT-specific prompt templates produce documentation that reflects the actual complexity of psychedelic-assisted therapy.",
    readingTime: "10 min read",
    metaDescription:
      "Practical guide to clinical prompt templates for psychedelic-assisted therapy. Covers the full PAT treatment arc, orientation-aware prompting, document chaining, and the MycenAI Clinical Prompt Library for intake, preparation, dosing, integration, and discharge documentation.",
    component: PatPromptTemplates,
  },
  {
    slug: "ai-in-psychedelic-assisted-therapy",
    title:
      "The Role of AI in Psychedelic-Assisted Therapy",
    date: "February 26, 2026",
    isoDate: "2026-02-26",
    description:
      "Psychedelic-assisted therapy generates more documentation than standard talk therapy, across more phases, with higher privacy stakes. Here is what AI-assisted documentation looks like for PAT practitioners.",
    readingTime: "9 min read",
    metaDescription:
      "How AI documentation tools support psychedelic-assisted therapy practitioners across preparation, dosing, and integration phases. Covers clinical prompt templates, document chaining, orientation-aware prompting, and hardware-secured privacy for PAT.",
    component: AiInPat,
  },
];

export function getBlogPost(slug: string): BlogPost | undefined {
  return blogPosts.find((post) => post.slug === slug);
}

export function getRelatedPosts(currentSlug: string, count = 3): BlogPost[] {
  return blogPosts
    .filter((post) => post.slug !== currentSlug)
    .slice(0, count);
}
